import { render, staticRenderFns } from "./historyMails.vue?vue&type=template&id=52208f99"
import script from "./historyMails.vue?vue&type=script&lang=js"
export * from "./historyMails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports